<template>
  <CCard>
    <CCardBody> 
      <CRow>

        <CCol class="col-lg-6 control-section">
          <ejs-tooltip ref="tooltip" target=".e-rowcell" >
          <ejs-grid 
            :dataSource="AcidityData" 
            ref='AcidityGrid'
            :allowExcelExport='true'
            locale='zh-TW' 
            height='58vh' 
            :queryCellInfo='onQueryCellInfo'
            :allowPaging='true' 
            :pageSettings='GridPageSettings' 
            :allowSorting='true' 
            :allowFiltering='true' 
            :filterSettings='filterSettings' 
            :editSettings='editSettings' 
            :toolbar='AcidityGridToolbar'
            :toolbarClick="AcidityToolbarClick"
            :rowSelected='AcidityGridRowSelected'>
              <e-columns>
                  <e-column field='create_date'  headerText='建立時間'     width='130' ></e-column>
                  <e-column field='adjust'      headerText='酸度值'       width='150' format='N2' textAlign='Right' editType='numericedit'></e-column>
                  <e-column field='create_id'    headerText='上傳者'   width='120' ></e-column>
              </e-columns>
          </ejs-grid>
        </ejs-tooltip>
        </CCol>
         <CCol class="col-lg-6 control-section chart-container">
            <ejs-chart style='display:block;display: block; height: 100%;' title='酸度曲線圖' :primaryXAxis='AdjustXAxis' :primaryYAxis='AdjustYPileAxis'
                     :width='width' :legendSettings='Adjustlegend' :tooltip='Adjusttooltip' >
              <e-series-collection>
                 <e-series
                  :dataSource="AdjustData"
                  type="Line"
                  xName="create_date"
                  yName="adjust"
                  width="2"
                  opacity="0.5"
                />
              </e-series-collection>
            </ejs-chart>
         </CCol>
      
      </CRow>
            <ejs-dialog 
            ref="AcidityDialog" 
            :showCloseIcon='true' 
            :isModal='true' 
            :closeOnEscape='true'  
            :visible='false' 
            :header='"設定酸度"' 
            :buttons='e_acidity_button' 
            width='58vh'>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <div class="alert alert-primary" role="alert">
                        配方設計是以8.5%原醋為主，故(ABC-002)原醋投料量=8.5*系統投料量/最新的酸度值；水量則為設定之投料量-原醋投料量。                        
                      </div>
                    </div>
                    <span class="about-title">酸度值%</span>   
                    <div class="form-group col-md-12">
                        <ejs-numerictextbox id="numeric" format="###.##" :step="0.1" v-model="e_acidity"></ejs-numerictextbox>      
                    </div> 
                  </div>
                  
                </ejs-dialog>
                <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    
    </CCardBody>
  </CCard>  
</template>
<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">
import Vue from "vue";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport } from "@syncfusion/ej2-vue-grids";
import { ChartComponent, SeriesDirective, SeriesCollectionDirective, ColumnSeries, DataLabel, LineSeries, SplineSeries, SplineAreaSeries, Legend, Tooltip, DateTime, Category, Highlight, ChartAnnotation, StripLine } from "@syncfusion/ej2-vue-charts";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import zhtwLocalization  from '../language/language.json';

L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
enableRipple(true);
let DialogObj   = undefined;
export default {
  components: {
     'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-chart': ChartComponent,
    'e-series-collection': SeriesCollectionDirective,
    'e-series': SeriesDirective,
    'ejs-toast': ToastComponent,
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport],
        chart: [ColumnSeries, SplineAreaSeries, LineSeries, SplineSeries, Legend, Tooltip, Category,DateTime, DataLabel, Highlight, ChartAnnotation, StripLine],
  },
  data: function() {
    return {  
      limit : localStorage.getItem('production'), 
      AcidityRowSelect:null,
      AcidityData: [],
      GridPageSettings: {pageSize: 50, pageSizes: [10,50,100,200], pageCount: 50 },
      filterSettings: { type: 'CheckBox' },
      editSettings: { allowEditing: false, allowAdding: true, allowDeleting: false },
      orderidrules: { required: true, number: true },
      customeridrules: { required: true, minLength: 5 },
      freightrules:  { required: true, min: 0 },
      AcidityGridToolbar: [
          { text: '新增', tooltipText: '新增投料', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false || localStorage.getItem('production').indexOf('42') < 0},
          { text: '刪除', tooltipText: '刪除投料', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: false || localStorage.getItem('production').indexOf('42') < 0 },
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' },
          'Search', 
           ], 
      AdjustData: [],

      AdjustXAxis: {
        valueType: 'DateTime',
        labelFormat: 'MM/dd HH:mm',  
        title: '檢測時間',
        intervalType: 'Minutes',
        edgeLabelPlacement: 'Shift',
        labelIntersectAction: 'Rotate45'
      },
      AdjustYPileAxis: {
        title: '酸度值 (pH)',
        minimum: 0,
        maximum: 20,
        interval: 2,
      },
      Adjustlegend: {
        visible: true
      },
      Adjusttooltip: {
        enable: true
      },
      width: '100%',
      //dialog
      e_acidity: 8.5,
      e_acidity_button: [
        {click: this.PostAcidity, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ], 
      //toast
       position: { X: 'Right', Y: "Bottom" },
    };
  },

  created() {
    this.getAcidity();
  },
  methods: { 
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    }, 
    AcidityToolbarClick: function (args) {
      if (args.item.id == "Export") {
          this.$refs.AcidityGrid.excelExport({ fileName:'酸度表.xlsx' });
      }
      if(args.item.id == 'Add') {
        this.$refs.AcidityDialog.show();
      }
      if(args.item.id == 'Delete') {
        if(this.AcidityRowSelect== null){
          this.$refs.toastRef.show( { title: '錯誤!', content: "請選擇要刪除的資料。", cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
         return; 
        }
        DialogObj = DialogUtility.confirm({
            title: '資料刪除',
            content: `確認是否要刪除${this.AcidityRowSelect.data.create_date}的資料嗎?刪除後可能會影響系統!`,
            okButton: {  text: '確認', click: this.DelAcidity },
            cancelButton: {  text: '取消', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });  

        
      }
    },
    AcidityGridRowSelected:function(args){
      this.AcidityRowSelect = args;
    },
    //showtost
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    //api
    getAcidity: function () { 
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Acidity`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.AcidityData = response.data.datas;
        this.AdjustData = response.data.datas;
      //   this.AdjustData = this.AdjustData.map(item => ({
      //   ...item,
      //   create_date: new Date(item.create_date.replace(" ", "T")) // "2025-05-20 10:17" -> "2025-05-20T10:17"
      // }))
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },
    PostAcidity: function () { 
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Acidity`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data:{
            adjust:this.e_acidity
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.$refs.AcidityDialog.hide();
        this.showMsg('新增成功!');    
        this.getAcidity();

      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },
    DelAcidity: function () { 
     
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Recipe/Acidity`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data:{
            acidity_id:this.AcidityRowSelect.data.acidity_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        DialogObj.hide(); 
        this.showMsg('刪除成功!'); 
        this.getAcidity();
        this.AcidityRowSelect=null; 
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
  },

}
</script>
<style lang="scss" src="../../scss/base.scss">
</style>